import * as types from './mutation-types'

const mutations = {
  [types.SET_EVENTLIST](state, eventlist) {
    state.eventlist = eventlist
  },
  [types.SET_SEARCH](state, search) {
    state.search = search
    state.page = 1;
  },
  [types.SET_TOTAL](state, total) {
    state.total = total
  },
  [types.SET_DATE_RANGE](state, range) {
    state.date_range = range
  },
  [types.SET_CLEAR_ALL](state) {
    state.search = ''
    state.page = 1;
    state.date_range = {
      type: '',
      start: '',
      end: ''
    };
    state.page = 1;
  },
  [types.SET_CLEAR_SEARCH](state) {
    state.search = ''
  },
  [types.SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [types.SET_PAGE](state, page) {
    state.page = page;
  },
  [types.SET_MONTH_EVENTS](state, month_events) {
    state.month_events = month_events;
  },
  [types.SET_CATEGORY_LIST](state, categorylist) {
    state.categorylist = categorylist;
  },
  [types.SET_FILTER](state, filter) {
    state.filter = filter;
  },

  [types.SET_SELECTED_CATEGORIES](state, { key, terms }) {
    // intialize
    if (!state.selectedCategories) {
      state.selectedCategories = {};
    }
    // restrict the adding terms that exist in other categories
    const termsToAdd = terms.filter((term) => {
      // Checking term exists in any other category
      return !Object.keys(state.selectedCategories).some(
        (categoryKey) => categoryKey !== key && state.selectedCategories[categoryKey].includes(term)
      );
    });
    if (termsToAdd.length > 0) {
      state.selectedCategories[key] = termsToAdd;
    }else {
      // Removing the key category_1[].. if the terms are empty
      delete state.selectedCategories[key];
    }
  },
  [types.OPEN_FILTER](state, categoryId) {
    if (!state.openFilters) {
      state.openFilters = {};
    }
    state.openFilters[categoryId] = true;
  },
  [types.SET_SELECTED_MONTH](state, month) {
    state.selectedMonth = month;
  },

  [types.SET_MONTH_VIEW](state, isMonthView) {
    state.isMonthView = isMonthView;
  },
  [types.SET_DATE_MANUALLY_SELECTED](state, flag) {
    state.isDateManuallySelected = flag;
  },
  [types.SET_NAVIGATION_DIRECTION](state, direction) {
    state.navigationDirection = direction;
  }
}

export default mutations
